module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-07.b2c269a8.jpg";